import Vue from "vue";
import Vuex from "vuex";
import service from "@/services/service";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    session: { id: null, user: null },
    messages: [],
    messageId: 0,
    currentVersions: {
      alphaVersion: null,
      betaVersion: null,
      releaseVersion: null,
      stableVersion: null
    }
  },
  mutations: {
    SET_SESSION(state, session) {
      state.session = session;
    },
    CLEAR_SESSION() {
      localStorage.removeItem("session");
      console.log("remove session");
      location.reload();
    },
    ADD_MESSAGE(state, message) {
      message.id = state.messageId++;
      state.messages.push(message);
    },
    DELETE_MESSAGE(state, id) {
      for (var i = 0, len = state.messages.length; i < len; i++) {
        if (state.messages[i].id === id) {
          return state.messages.splice(i, 1);
        }
      }
    },
    SET_CURRENT_VERSIONS(state, currentVersions) {
      state.currentVersions = currentVersions;
    }
  },
  actions: {
    addMessage({ commit }, message) {
      commit("ADD_MESSAGE", message);
      if (message.timeout) {
        setTimeout(() => {
          commit("DELETE_MESSAGE", message.id);
        }, 5000);
      }
    },
    deleteMessage({ commit }, id) {
      commit("DELETE_MESSAGE", id);
    },
    login({ commit }, session) {
      commit("SET_SESSION", session);
      service.setAuthHeader(session);
      service.getCurrentVersions().then(response => {
        commit("SET_CURRENT_VERSIONS", response.data[0]);
      });
    },
    logout({ commit }) {
      service.setAuthHeader(null);
      commit("CLEAR_SESSION");
    },
    setCurrentVersions({ commit }, currentVersions) {
      commit("SET_CURRENT_VERSIONS", currentVersions);
    }
  },
  getters: {
    loggedIn(state) {
      return !!(state.session != null && state.session.id);
    }
  }
});
